import { PageHeader } from "@components/page/PageHeader"
import { SubpageContentBlocks } from "@components/page/SubpageContentBlocks"
import { defineView } from "eddev/views"

export default defineView("single-venue", (props) => {
  const links = []
  links.push({ title: "Visit Website", url: props.venue?.info?.website!, target: "_blank" })

  return (
    <>
      <SubpageContentBlocks blocks={props.venue?.contentBlocks} />
      <div className="h-10" />
    </>
  )
})
